<script setup lang="ts">
import {
  computed,
  ref,
} from 'vue';
import { useRouter } from 'vue-router';

import type { VButtonProps } from '@components/buttons/VButton/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import { onComponentActivated } from '@modules/core/composables/vue';

import type {
  VBackButtonEmits,
  VBackButtonProps,
} from './types';

const props = withDefaults(defineProps<VBackButtonProps>(), {});
const emit = defineEmits<VBackButtonEmits>();

const router = useRouter();

const backLocationUrl = ref<string>();

onComponentActivated(() => {
  backLocationUrl.value = window.history.state?.back;
});

const buttonProps = computed<VButtonProps>(() => ({
  ...props,
  to: backLocationUrl.value && !props.skipHistory ? router.resolve(backLocationUrl.value) : props.to,
  prevented: true,
  raised: false,
  outlined: !props.notOutlined,
}));

function onClick(event: MouseEvent): void {
  if (props.loading) {
    return;
  }

  if (props.skipHistory) {
    void router.push(props.to);
  } else {
    router.back(props.to);
  }

  emit('click', event);
}
</script>

<template>
  <VButton v-data-qa-auto-id="'VBackButton'"
    v-bind="buttonProps"
    @click.prevent="onClick"
  />
</template>
